var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeartLight = function SvgIconHeartLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_heart_light_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.582 13.185c-2.368.428-4.35 2.216-5.134 4.548-.832 2.767.298 5.066 2.05 6.91l.024.026c.772.868 5.633 5.73 8.756 8.853.97.97 2.574.97 3.544 0 1.55-1.55 3.548-3.547 5.245-5.27 1.73-1.755 3.066-3.143 3.365-3.527.028-.036.058-.07.09-.103 1.815-1.815 2.871-4.112 2.025-6.903l-.005-.017c-.683-2.391-2.736-4.176-5.098-4.513l-.014-.002c-2.724-.426-5.208.934-6.497 2.996a1.1 1.1 0 0 1-1.876-.017c-1.274-2.123-3.734-3.405-6.475-2.981Zm7.433.583c-1.853-2.091-4.705-3.236-7.785-2.755l-.023.004c-3.222.575-5.832 2.978-6.85 6.035l-.01.029c-1.157 3.82.503 6.911 2.543 9.064.858.958 5.69 5.79 8.756 8.857l.076.076a4.721 4.721 0 0 0 6.656 0l.001-.002c1.55-1.549 3.552-3.551 5.254-5.279 1.611-1.634 3.031-3.1 3.49-3.664 2.16-2.181 3.674-5.264 2.532-9.044-.918-3.202-3.66-5.612-6.892-6.077-3.08-.479-5.907.738-7.748 2.756Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_heart_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 11)",
    d: "M0 0h30.2v25.4H0z"
  })))));
};
export default SvgIconHeartLight;